<template>
  <div id="activity" class="maincont child output-csv-screen">
    <div class="ef--inner ef--large-inner content-block">
      <aside class="side-bar" id="left-side-nav">
        <ul>
          <li>
            <i class="remark-ic" :class="{'active': typeSelected === 1}"></i>
            <i class="icon" @click="changeType(1)">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                <path d="M9.828 3h3.982a2 2 0 0 1 1.992 2.181l-.637 7A2 2 0 0 1 13.174 14H2.825a2 2 0 0 1-1.991-1.819l-.637-7a1.99 1.99 0 0 1 .342-1.31L.5 3a2 2 0 0 1 2-2h3.672a2 2 0 0 1 1.414.586l.828.828A2 2 0 0 0 9.828 3zm-8.322.12C1.72 3.042 1.95 3 2.19 3h5.396l-.707-.707A1 1 0 0 0 6.172 2H2.5a1 1 0 0 0-1 .981l.006.139z"/>
              </svg>
            </i>
            <span class="txt-type-title" @click="changeType(1)">すべてのファイル</span>
          </li>
          <li>
            <i class="remark-ic" :class="{'active': typeSelected === 2}"></i>
            <i class="icon" @click="changeType(2)">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                <path d="M8 3.5a.5.5 0 0 0-1 0V9a.5.5 0 0 0 .252.434l3.5 2a.5.5 0 0 0 .496-.868L8 8.71V3.5z"/>
                <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm7-8A7 7 0 1 1 1 8a7 7 0 0 1 14 0z"/>
              </svg>
            </i>
            <span class="txt-type-title" @click="changeType(2)">最新</span>
          </li>
          <li>
            <i class="remark-ic" :class="{'active': typeSelected === 3}"></i>
            <i class="icon" @click="changeType(3)">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                <path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z"/>
              </svg>
            </i>
            <span class="txt-type-title" @click="changeType(3)">お気に入り</span>
          </li>
        </ul>
      </aside>
      <main class="sidebar-main" id="right-side-nav">
        <div class="container w-100">
          <nav aria-label="breadcrumb">
            <ul class="breadcrumb">
              <li class="breadcrumb-item">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                  <path d="M8.707 1.5a1 1 0 0 0-1.414 0L.646 8.146a.5.5 0 0 0 .708.708L8 2.207l6.646 6.647a.5.5 0 0 0 .708-.708L13 5.793V2.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1.293L8.707 1.5Z"/>
                  <path d="m8 3.293 6 6V13.5a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 2 13.5V9.293l6-6Z"/>
                </svg>
              </li>
              <li class="breadcrumb-item" v-if="year">{{ year }}</li>
              <li class="breadcrumb-item" v-if="month">{{ month }}</li>
            </ul>
          </nav>
          <div class="scroll w-100" style="height: 580px;">
            <table class="tree-tbl">
              <thead>
                <tr>
                  <th>
                    <div>
                      <span>名前</span>
                      <svg v-if="sortType==='asc'" @click="sortType = 'desc', foldersSort()" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="ic-sort" viewBox="0 0 16 16">
                        <path d="m7.247 4.86-4.796 5.481c-.566.647-.106 1.659.753 1.659h9.592a1 1 0 0 0 .753-1.659l-4.796-5.48a1 1 0 0 0-1.506 0z"/>
                      </svg>
                      <svg v-if="sortType==='desc'" @click="sortType = 'asc', foldersSort()" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="ic-sort" viewBox="0 0 16 16">
                        <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"/>
                      </svg>
                    </div>
                  </th>
                  <th></th>
                  <th>サイズ</th>
                  <th>更新日時</th>
                </tr>
              </thead>
              <tbody>
                <tr class="collapse" v-bind:class="'level' + folder.level" v-for="(folder, index) in folders" :key="index">
                  <td v-show="folder.visibility">
                    <div class="item">
                      <svg v-if="!folder.size" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                        <path d="M9.828 3h3.982a2 2 0 0 1 1.992 2.181l-.637 7A2 2 0 0 1 13.174 14H2.825a2 2 0 0 1-1.991-1.819l-.637-7a1.99 1.99 0 0 1 .342-1.31L.5 3a2 2 0 0 1 2-2h3.672a2 2 0 0 1 1.414.586l.828.828A2 2 0 0 0 9.828 3zm-8.322.12C1.72 3.042 1.95 3 2.19 3h5.396l-.707-.707A1 1 0 0 0 6.172 2H2.5a1 1 0 0 0-1 .981l.006.139z"/>
                      </svg>
                      <svg v-if="folder.size" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                        <path d="M5.5 7a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1h-5zM5 9.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5z"></path>
                        <path d="M9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.5L9.5 0zm0 1v2A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5z"></path>
                      </svg>
                      <span @click="showDetail(folder, index)">{{ folder.name }}</span>
                    </div>
                  </td>
                  <td v-show="folder.visibility">
                    <div class="item menu-item-setting" @click="showSettingMenu(folder)">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                        <path d="M3 9.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z"/>
                      </svg>
                      <ul class="menu-item-setting-content" v-bind:class="{'hidden': !folder.showMenu}">
                        <li v-if="folder.size" @click="addFavorite(folder, folder.key)">
                          <svg class="ml-4 mr-4" xmlns="http://www.w3.org/2000/svg" width="16" height="16" :fill="folder.fillColor" viewBox="0 0 16 16">
                            <path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z"></path>
                          </svg>
                          <span>{{ folder.favorite ? 'お気に入り解除' : 'お気に入りに登録' }}</span>
                        </li>
                        <li @click="onChangeName(folder)">
                          <svg class="ml-4 mr-4" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                            <path d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708l-3-3zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207l6.5-6.5zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.499.499 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11l.178-.178z"></path>
                          </svg>
                          <span>名前の変更</span>
                        </li>
                        <li v-if="folder.size" @click="downloadFile(folder.key)">
                          <svg class="ml-4 mr-4" width="16" height="16" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                            <path d="M13 8V2H7v6H2l8 8 8-8h-5zM0 18h20v2H0v-2z"></path>
                          </svg>
                          <span>ダウンロード</span>
                        </li>
                      </ul>
                    </div>
                  </td>
                  <td v-show="folder.visibility">
                    <div class="item" v-if="folder.size">{{ folder.size }}</div>
                    <div class="item" v-if="!folder.size"></div>
                  </td>
                  <td v-show="folder.visibility">
                    <div class="item">{{ folder.datetime }}</div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </main>
      <div class="toggle-nav-icon">
        <svg
          viewBox="0 0 100 80"
          width="24"
          height="24"
          fill="#4e4d4d"
          @click="toggleNav()"
        >
          <rect width="100" height="20"></rect>
          <rect y="30" width="100" height="20"></rect>
          <rect y="60" width="100" height="20"></rect>
        </svg>
      </div>
    </div>
    <CSVOutputChangeNameDialog
      @close="showChangeNameModal = false"
      v-if="showChangeNameModal"
      :item="itemChangeName"
      @updateFileName="updateFileName">
    </CSVOutputChangeNameDialog>
  </div>
</template>

<script>
/* eslint-disable */
import CSVOutputChangeNameDialog from '../../components/CSVOutputChangeNameDialog'
export default {
  name: "output_csv",
  components: {
    CSVOutputChangeNameDialog
  },

  data: function() {
    return {
      year: '',
      month: '',
      folders: [],
      showChangeNameModal: false,
      itemChangeName: {},
      typeSelected: 1,
      sortType: 'asc'
    };
  },

  methods: {
    toggleNav: function() {
      const leftSideNav = document.getElementById("left-side-nav")
      const rightSideNav = document.getElementById("right-side-nav")
      if (leftSideNav.style.display === "block") {
        leftSideNav.style.display = "none"
        rightSideNav.style.display = "block"
      } else {
        leftSideNav.style.display = "block"
        rightSideNav.style.display = "none"
      }
    },
    changeType: function(type) {
      if (type === this.typeSelected) {
        return
      }
      this.typeSelected = type
      this.getAllFiles()
    },
    getAllFiles: function() {
      console.log("[output_csv] getAllFiles")
      const params = new URLSearchParams()
        params.append('type', this.typeSelected)
        params.append('sortType', this.sortType)

        const request = {
            params: params,
            withCredentials: true
        };
      this.$axios
        .get(`/srv/api/output_csv`, request)
        .then(response => {
          console.log("[GET][api/output_csv] : OK");
          if (typeof response.data == "object") {
            this.processingFolders(response.data.folders)
          } else {
            // stringのときはセッションタイムアウト
            alert("sesssion time out");
            this.$store.dispatch("logout");
            this.$router.push("/login");
          }
        })
        .catch(error => {
          console.log(error);
        })
    },
    processingFolders: function(data) {
      data.forEach(item => {
        item['visibility'] = false
        item['showDetail'] = false
        item['fillColor'] = item.favorite ? '#005cc0' : ''
        if (item.level === 0) {
          item['visibility'] = true
        }
      })
      this.folders = data
    },
    showDetail: function(item, index) {
      const keyClicked = item.key
      this.showBreadcrumbTitle(item)
      if (item.showDetail) {
        for (let i = index + 1; i < this.folders.length; i++) {
          const folder = this.folders[i]
          if (folder.key.includes(keyClicked)) {
            folder.visibility = false
            folder.showDetail = false
          }
        }
      } else {
        const nextLevel = item.level + 1
        for (let i = index + 1; i < this.folders.length; i++) {
          const folder = this.folders[i]
          if (folder.level === nextLevel && folder.key.includes(keyClicked)) {
            folder.visibility = true
          }
        }
      }
      item.showDetail = !item.showDetail
      this.$forceUpdate()
    },
    showBreadcrumbTitle: function (item) {
      const key = item.key
      const subKeys = key.split('/').filter(x => x)
      subKeys.forEach(item => {
        if (item.includes('年')) {
          this.year = item
        }
        if (item.includes('月')) {
          this.month = item
        }
      })
    },
    showSettingMenu: function(item) {
      const keyItemClicked = item.key
      const itemShowMenu = this.folders.filter(x => x.showMenu)
      if (itemShowMenu.length) {
        itemShowMenu.forEach(element => {
          if (element.key !== keyItemClicked) {
            element.showMenu =  false
          }
        })
      }
      item.showMenu = !item.showMenu
      this.$forceUpdate()
    },
    addFavorite: function(item, key) {
      console.log(`[addFavorite with file_key: ]${key}`)
      const params = { file_key: key}
      this.$axios
        .post(`/srv/api/output_csv/favorite`, params, { withCredentials: true })
        .then(response => {
          const data = response.data;
          if (data.status !== undefined) {
              if (data.status === "success") {
                console.log("[POST][api/output_csv/favorite] : OK")
                if (item.favorite) {
                  alert("お気に入りから解除しました");
                } else {
                  alert("登録が完了しました。");
                }
                
                item.favorite = !item.favorite
                item.fillColor = item.favorite ? '#005cc0' : ''
                if (this.typeSelected === 3 && !item.favorite) {
                  const index = this.folders.indexOf(item);
                  if (index > -1) {
                    this.folders.splice(index, 1);
                  }  
                }
                
              } else {
                console.log("[POST][api/output_csv/favorite] : fail")
                alert("登録できませんでした");
              }
          } else {
            console.log("[POST][api/output_csv/favorite] : fail")
            alert("登録できませんでした");
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    downloadFile: function(key) {
      console.log(`[downloadFile with file_key: ]${key}`)
      const params = { file_key: key}
      this.$axios
        .post(`/srv/api/output_csv/download`, params, { withCredentials: true })
        .then(response => {
          const data = response.data;
          if (data.status !== undefined) {
            if (data.status === "success") {
              console.log("[POST][api/output_csv/download] : OK")
              window.open(data.file_url)
            } else {
              console.log("[POST][api/output_csv/download] : fail")
              alert("ファイルダウンロードが失敗しました");
            }
          } else {
            console.log("[POST][api/output_csv/download] : fail")
            alert("ファイルダウンロードが失敗しました");
          }
      })
      .catch(error => {
        console.log(error)
      })
    },
    onChangeName: function(item) {
      console.log(`[Button [名前の変更] clicked: ]${item.name}`)
      this.itemChangeName = item
      this.showChangeNameModal = true
    },
    updateFileName: function(newName) {
      console.log(`[updateFileName with key: ]${this.itemChangeName.key}`)
      const params = {
        key: this.itemChangeName.key,
        old_name: this.itemChangeName.name,
        new_name: newName,
        idx: this.itemChangeName.idx,
        type: this.typeSelected
      }
      this.$axios
        .post(`/srv/api/output_csv/change_name`, params, { withCredentials: true})
        .then(response => {
          const data = response.data;
          if (data.status !== undefined) {
            if (data.status === "success") {
              console.log("[POST][api/output_csv/change_name] : OK")
              const folders = data.names
              folders.forEach(element => {
                const idx = element.idx
                const oldIndexItem = this.folders.findIndex(x => x.idx === idx)
                if (oldIndexItem > -1) {
                  this.folders[oldIndexItem].name = element.name
                  this.folders[oldIndexItem].key = element.key
                }
              })
              alert("ファイル名が正常に更新しました")
            } else {
              console.log("[POST][api/output_csv/change_name] : fail")
              alert("ファイル名更新が失敗した")
            }
          } else {
            console.log("[POST][api/output_csv/change_name] : fail")
            alert("ファイル名更新が失敗した")
          }
      })
      .catch(error => {
        console.log(error)
      })
      this.showChangeNameModal = false
      this.itemChangeName = {}
    },
    makeTree: function(arr) {
      let tree = {};
      for (let i = 0; i < arr.length; i++) {
          if (!tree[arr[i].parent]) tree[arr[i].parent] = [];
          tree[arr[i].parent].push(arr[i]);
      }
      return tree;
    },
    depthFirstTraversal: function(tree, id, cmp, callback) {
      let children = tree[id];
      if (children) {
          children.sort(cmp);
          for (let i = 0; i < children.length; i++) {
              callback(children[i]);
              this.depthFirstTraversal(tree, children[i].idx, cmp, callback);
          }
      }
    },
    depthFirstTreeSort: function(arr, cmp) {
      // Returns an object, where each key is a node number, and its value
      // is an array of child nodes.
      let i = 0;
      this.depthFirstTraversal(this.makeTree(arr), 0, cmp, function(node) {
          arr[i++] = node;
      });
    },
    nameAscCmp: function(a, b) { 
      return a.name.localeCompare(b.name)
    },
    nameDescCmp: function(a, b) { 
      return b.name.localeCompare(a.name)
    },
    foldersSort() {
      if (this.sortType === 'asc') {
        this.depthFirstTreeSort(this.folders, this.nameAscCmp)
      } else {
        this.depthFirstTreeSort(this.folders, this.nameDescCmp)
      }
    }
  },

  mounted: function() {
    this.getAllFiles()
  },
};
</script>
